import React, { useState } from "react";
import {
    Alert,
    Avatar,
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const ForgetPassword = () => {
    /* ---------------- state ---------------- */
    const [form, setForm] = useState({
        email: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [alert, setAlert] = useState({ show: false, msg: "", severity: "info" });

    /* -------------- nav + media ------------ */
    const navigate = useNavigate();
    const theme = useTheme();
    const downSm = useMediaQuery(theme.breakpoints.down("sm")); // <600 px

    /* -------------- handlers --------------- */
    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const flash = (msg, severity) => {
        setAlert({ show: true, msg, severity });
        setTimeout(() => setAlert({ ...alert, show: false }), 3000);
    };

    const handleConfirm = () => {
        if (form.newPassword !== form.confirmPassword) {
            flash("Passwords do not match", "error");
            return;
        }

        axios
            .post("https://music-endpoint.onrender.com/auth/forgot-password", form)
            .then(({ data }) => {
                if (data.status === "OK") {
                    flash(data.message, "success");
                    setTimeout(() => navigate("/auth"), 1000);
                } else {
                    flash(data.message || "Something went wrong", "error");
                }
            })
            .catch((err) =>
                flash(
                    err.response?.data?.message || "Password reset failed",
                    "error"
                )
            );
    };

    /* -------------- render ----------------- */
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
            }}
        >
            {alert.show && (
                <Alert
                    severity={alert.severity}
                    sx={{
                        position: "fixed",
                        top: 16,
                        width: { xs: "90%", sm: 400 },
                        maxWidth: "90%",
                        zIndex: 1201,
                    }}
                >
                    {alert.msg}
                </Alert>
            )}

            <Paper
                elevation={3}
                sx={{
                    width: { xs: "100%", sm: 420, md: 400 },
                    p: { xs: 3, sm: 4 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 2.5,
                    alignItems: "center",
                    borderRadius: { xs: 0, md: 4 },
                }}
            >
                <Avatar sx={{ bgcolor: "black", width: 56, height: 56 }}>
                    <AccountCircleOutlinedIcon fontSize="large" />
                </Avatar>

                <Typography variant={downSm ? "h5" : "h4"}>Forgot password</Typography>

                <TextField
                    label="Email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    fullWidth
                />

                <TextField
                    label="New password"
                    name="newPassword"
                    type="password"
                    value={form.newPassword}
                    onChange={handleChange}
                    fullWidth
                />

                <TextField
                    label="Confirm password"
                    name="confirmPassword"
                    type="password"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    fullWidth
                />

                <Button variant="contained" fullWidth onClick={handleConfirm}>
                    Confirm
                </Button>

                <Typography variant="body2">
                    Already have an account? <Link to="/auth">Login</Link>
                </Typography>
            </Paper>
        </Box>
    );
};

export default ForgetPassword;
